__turbopack_context__.v({
  "actions": "nPUh7q_actions",
  "content": "nPUh7q_content",
  "logoLink": "nPUh7q_logoLink",
  "navLinks": "nPUh7q_navLinks",
  "tabletContent": "nPUh7q_tabletContent",
  "webContent": "nPUh7q_webContent",
  "wrapper": "nPUh7q_wrapper",
});
